import { Checkbox, Classes, Position } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { Inbound } from 'src/components/icons/Inbound';
import { Outbound } from 'src/components/icons/Outbound';
import { TEST_IDS } from 'src/constants/testIds';
import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import * as copy from 'src/templates/copy';

type ProjectDiagramClassDrawerRelationshipsDirectionsProps = {
  directions: RelationshipDirection[];
  setDirections?: (directions: RelationshipDirection[]) => void;
};

export const ProjectDiagramClassDrawerRelationshipsDirections: React.VFC<
  ProjectDiagramClassDrawerRelationshipsDirectionsProps
> = ({ directions, setDirections }) => {
  const handleCheckboxChange =
    (direction: RelationshipDirection) =>
    (evt: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = evt.target;

      const newDirections = new Set(directions);

      if (checked) {
        newDirections.add(direction);
      } else {
        newDirections.delete(direction);
      }

      setDirections?.(Array.from(newDirections));
    };

  return (
    <div className={Classes.INLINE}>
      <Checkbox
        checked={directions.includes(RelationshipDirection.OUTGOING)}
        className={classNames('sd-checkbox', {
          'sd-checkbox--read-only': !setDirections,
        })}
        data-testid={TEST_IDS.projectDiagram.entityDrawer.outgoingCheckbox}
        onChange={handleCheckboxChange(RelationshipDirection.OUTGOING)}
      >
        <Tooltip
          content={
            copy.components.projectDiagram.classDrawer.relationshipsTable
              .directionOutgoing
          }
          position={Position.TOP}
        >
          <Outbound />
        </Tooltip>
      </Checkbox>
      <Checkbox
        checked={directions.includes(RelationshipDirection.INCOMING)}
        className={classNames('sd-checkbox', {
          'sd-checkbox--read-only': !setDirections,
        })}
        data-testid={TEST_IDS.projectDiagram.entityDrawer.incomingCheckbox}
        onChange={handleCheckboxChange(RelationshipDirection.INCOMING)}
      >
        <Tooltip
          content={
            copy.components.projectDiagram.classDrawer.relationshipsTable
              .directionIncoming
          }
          position={Position.TOP}
        >
          <Inbound />
        </Tooltip>
      </Checkbox>
    </div>
  );
};
